<template>
  <myhead @next="next" @lookmore="more">{{ $route.query.title || $route.meta.title}}</myhead>
  <div class="pad14 size14" style="height:calc(100vh - 49px)" ref="wrapper" @scroll.passive="isScrollBottom">
    <p class="BGon opacity7 line32 Cfff flex mb14" style="position: sticky;top:44px;left:0;right:0;z-idex:1;padding:0 10px 0 15px">
      <span class="width35">姓名</span>
      <span class="width16 center">票数</span>
      <span class="width16 center">选项</span>
      <span class="flex1" style="text-align:right">时间</span>
    </p>
    <van-empty description="暂无数据" class="mt50" v-if="list.length==0" />
    <li v-for="item,index in list" :key="index" class="flex ml15 mr10">
      <div class="width35 flex nowrap">
        <img :src="item.head_pic" :onerror="userError" class="height24px width24px radius20 mr15 BGf8" alt="">
        <p class="ellipsis">{{item.realname || '-'}}</p>
      </div>
      <p class="width16 center">{{item.vote}}</p>
      <p class="width16 center">{{item.no}}</p>
      <p class="flex1 C888" style="text-align:right">{{item.add_time}}</p>
      <p class="width100 pad7"></p>
    </li>
  </div>
</template>

<script>
export default {
  data () {
    return {
      list: []
    }
  },
  watch: {
    active () {
      this.getList();
    }
  },
  methods: {
    getList (page) {
      this.page = page || this.page;
      let list = this.list;
      if (this.page > 1) {
        if (this.page > this.count) {
          return this.page = this.count;
        }
      } else {
        list = [];
      }
      // typeid 1-调研中 2-已截止
      let url = 'forum/getvotelist';
      let params = {
        id: this.$route.query.id
      }
      if (this.$route.path.includes('vote/plebiscite')) {
        url = 'rulelaws/getvotelist'
        params = this.$route.query
      } else if (this.$route.path.includes('vote/list')) {
        url = 'rulelaws/getvotelist'
        params = this.$route.query
      }
      params = { ...params, page: this.page, keyword: this.keyword }
      this.ajax.post(url, params).then(({ data, count }) => {
        this.list = list.concat(data);
        this.count = count;
      })
    },
    isScrollBottom () {
      // 是否滚动到了底部
      this.box = this.$refs.wrapper
      var clientHeight = this.box.clientHeight
      var scrollTop = this.box.scrollTop
      var scrollHeight = this.box.scrollHeight
      if (scrollTop + clientHeight == scrollHeight) {
        this.getList(this.page + 1);
      }
    },
    next () {
      this.active = this.active < 2 ? this.active + 1 : 0;
      this.getList()
    },
  },
  created () {
    this.getList()
  }
}
</script>

<style lang="scss">
</style>
